export default __webpack_public_path__ + "static/media/school_design_3.6abdea47.png";